import React from 'react';
import { object } from 'prop-types';
import { Button } from '@ajaibid/components';

import useOrderAction from '../../hooks/useOrderAction';
import { styActionButtonsContainer } from './style';

/**
 * @typedef {import('@services/api/stock/order/dt').OrderDt} OrderDt
 */

/**
 * @param {object}  Params
 * @param {OrderDt} Params.order
 */
function ActionButtons({ order }) {
  const isAmmendable = order.is_amend === '1';
  const isCancelable = order.is_cancel === '1';

  const { amend, withdraw } = useOrderAction('DAY_TRADING');

  return (
    <span className={styActionButtonsContainer}>
      {isAmmendable && (
        <Button variant="secondary" minWidth={null} onClick={() => amend(order)}>
          Ubah
        </Button>
      )}
      {isCancelable && (
        <Button variant="secondary" minWidth={null} onClick={() => withdraw(order)}>
          Batalkan
        </Button>
      )}
    </span>
  );
}

ActionButtons.propTypes = {
  order: object.isRequired,
};

export default ActionButtons;
